/**
 * Return type for generated codes
 */
export var ReturnType;
(function (ReturnType) {
    /**
     * Return as base64 data string
     */
    ReturnType["Data"] = "Data";
    /**
     * Return as downloadable file
     */
    ReturnType["File"] = "File";
    /**
     * Return as publicly accessible URL
     */
    ReturnType["Url"] = "Url";
})(ReturnType || (ReturnType = {}));
//# sourceMappingURL=ReturnType.js.map